module.exports = __webpack_public_path__ + "static/media/red-tick.81e59d94.png";